import dayjs from 'dayjs';

export const formatDateRange = (
  startDate?: string,
  endDate?: string
): string => {
  if (!startDate || !endDate) return '-';
  return `${dayjs(startDate).format('DD.MM.YYYY')} - ${dayjs(endDate).format('DD.MM.YYYY')}`;
};

export const calculateProgress = (
  startDate: string,
  endDate: string
): number => {
  const end = dayjs(endDate);
  const start = dayjs(startDate);
  const now = dayjs();

  const totalDuration = end.diff(start);
  const elapsed = now.diff(start);

  if (elapsed < 0) return 0;
  if (elapsed >= totalDuration) return 100;
  return (elapsed / totalDuration) * 100;
};
